import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useWallet, txDisplayName, txCategoryLabel, txTimeLabel } from '../../contexts/WalletContext';

const Activity = ({ onBack, t, isRTL }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const { transactions: allTransactions } = useWallet();

  const tr = t || {
    allTx: 'All', sentTx: 'Sent', receivedTx: 'Received',
    activityTitle: 'Activity', txCount: 'tx',
  };

  const filters = [
    { id: 'all', label: tr.allTx },
    { id: 'sent', label: tr.sentTx },
    { id: 'received', label: tr.receivedTx },
  ];

  const filtered = allTransactions.filter((tx) => {
    if (activeFilter === 'sent') return !tx.positive;
    if (activeFilter === 'received') return tx.positive;
    return true;
  });

  return (
    <div
      data-testid="activity-screen"
      className="no-scrollbar"
      style={{
        background: '#0F0F0F',
        height: '100%',
        fontFamily: 'Inter, sans-serif',
        overflowY: 'auto',
        paddingBottom: '12px',
        direction: isRTL ? 'rtl' : 'ltr',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 20px 14px' }}>
        <h2 style={{ color: '#F5F1EA', fontSize: '20px', fontWeight: '800', margin: 0, letterSpacing: '-0.7px' }}>{tr.activityTitle}</h2>
        <div style={{ background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: '9px', padding: '5px 11px' }}>
          <span style={{ color: '#D4AF37', fontSize: '10px', fontWeight: '600' }}>{filtered.length} {tr.txCount}</span>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '7px', padding: '0 20px 18px', overflowX: 'auto' }} className="no-scrollbar">
        {filters.map((f) => (
          <motion.button
            key={f.id}
            whileTap={{ scale: 0.95 }}
            onClick={() => setActiveFilter(f.id)}
            style={{ padding: '7px 16px', borderRadius: '100px', background: activeFilter === f.id ? 'rgba(212,175,55,0.12)' : 'rgba(255,255,255,0.04)', border: activeFilter === f.id ? '1px solid rgba(212,175,55,0.25)' : '1px solid rgba(255,255,255,0.07)', color: activeFilter === f.id ? '#D4AF37' : '#8B93A7', fontSize: '12px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}
          >
            {f.label}
          </motion.button>
        ))}
      </div>

      <div style={{ padding: '0 20px' }}>
        <AnimatePresence mode="popLayout">
          {filtered.map((tx, i) => (
            <motion.div
              key={tx.id}
              layout
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.25, delay: i * 0.03 }}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: i < filtered.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '11px' }}>
                <div style={{ width: '42px', height: '42px', borderRadius: '14px', background: tx.positive ? 'rgba(74,222,128,0.07)' : 'rgba(255,255,255,0.05)', border: tx.positive ? '1px solid rgba(74,222,128,0.1)' : '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>{tx.icon}</div>
                <div>
                  <p style={{ color: '#F5F1EA', fontSize: '13px', fontWeight: '600', margin: '0 0 2px', letterSpacing: '-0.2px' }}>{txDisplayName(tx, t)}</p>
                  <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                    <span style={{ color: '#8B93A7', fontSize: '10px' }}>{txTimeLabel(tx, t)}</span>
                    <div style={{ width: '2px', height: '2px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)' }} />
                    <span style={{ color: '#8B93A7', fontSize: '9px', background: 'rgba(255,255,255,0.04)', padding: '1px 5px', borderRadius: '3px' }}>{txCategoryLabel(tx, t)}</span>
                  </div>
                </div>
              </div>
              <span style={{ color: tx.positive ? '#4ADE80' : '#F5F1EA', fontSize: '13px', fontWeight: '700', letterSpacing: '-0.3px', flexShrink: 0 }}>
                {tx.amount} MAD
              </span>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Activity;
